import FeedbackIcon from '@mui/icons-material/Feedback';
import { Box, MenuItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';
import { useGetEmployeeById } from '../../../services/react-query/employees';
import { useGetCurrentUser } from '../../../services/react-query/users/useGetCurrentUser';
import { menuItemLayout } from '../../common/popover/userPopover/userPopoverStyles';

const CannyFeedback: React.FC = () => {
  const { data: currentUser } = useGetCurrentUser();
  const { data: currentEmployeeData } = useGetEmployeeById({ uuid: 'current' });

  useEffect(() => {
    if ((window as any).Canny && currentUser) {
      const payload = {
        appID: '679c5bc55d298e1cb1aff5cf',
        user: {
          email: currentUser.email,
          id: currentUser.uuid,
          name: currentEmployeeData?.display_name || currentUser.email,
        },
      };
      (window as any).Canny('identify', payload);
    }
  }, [currentUser, currentEmployeeData]);

  return (
    <Box sx={{ height: '100%' }}>
      <MenuItem component="a" href="https://schedulink.canny.io" target="_blank" rel="noopener noreferrer" sx={menuItemLayout}>
        <FeedbackIcon color="action" />
        <Typography>Feedback</Typography>
      </MenuItem>
    </Box>
  );
};

export default CannyFeedback;
